export const FEATURES = [
  {
    icon: '🏊',
    bg: '#e0f2fe',
    title: 'Olympic Pools',
    desc:
      'Three heated Olympic-standard pools maintained at precise temperatures for competitive and recreational swimmers.',
  },
  {
    icon: '🎓',
    bg: '#f0fdf4',
    title: 'Expert Coaching',
    desc:
      'Certified coaches for group and private lessons — toddler paddlers to competitive athletes.',
  },
  {
    icon: '💪',
    bg: '#fef3c7',
    title: 'Fitness Programs',
    desc:
      'Aqua aerobics, water polo, and lap swimming programs tailored to your fitness goals.',
  },
  {
    icon: '🔒',
    bg: '#fdf2f8',
    title: 'Safe & Secure',
    desc:
      'Lifeguards on duty at all times. CCTV, first-aid stations, and strict safety protocols.',
  },
  {
    icon: '🧖',
    bg: '#f0f9ff',
    title: 'Spa & Recovery',
    desc:
      'Jacuzzi, steam room, and cryotherapy tubs for full recovery after intense sessions.',
  },
  {
    icon: '📱',
    bg: '#fafaf0',
    title: 'Smart Booking',
    desc:
      'Reserve lanes, classes, and lockers in seconds via the SwimWay app — no queues.',
  },
]

export const BUBBLES = [
  { w: 80, l: '5%', t: '15%', d: '0s' },
  { w: 120, l: '20%', t: '65%', d: '1.2s' },
  { w: 55, l: '72%', t: '20%', d: '2.4s' },
  { w: 160, l: '80%', t: '45%', d: '0.6s' },
  { w: 90, l: '40%', t: '82%', d: '1.8s' },
  { w: 140, l: '62%', t: '72%', d: '3.0s' },
]